import { render, staticRenderFns } from "./ActualNews.vue?vue&type=template&id=907b7d60"
import script from "./ActualNews.vue?vue&type=script&lang=js"
export * from "./ActualNews.vue?vue&type=script&lang=js"
import style0 from "./ActualNews.vue?vue&type=style&index=0&id=907b7d60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports